
import { Component, Vue, Prop } from "vue-property-decorator";
import NR, { CodeForm, LoginFrom, Info, Login } from "@/lib/model/NRXQ/NRXQ";
import { ElForm } from "element-ui/types/form";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import Reg from "@/lib/common/Reg";
import QA from "./QA.vue";

import Config from "@/config/config";

@Component({
  components: {
    QA
  }
})
export default class AiLogin extends Vue {
  @Prop({ default: "", type: String }) connectCode!: string;
  @Prop({ default: true, type: Boolean }) isPc!: boolean;

  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  formElement!: ElForm;
  sendingCaptchaLock = false;
  loginLock = false;
  captchaLoginError = false;
  captchaErrorText = "";
  isSelected = false;
  locationOrigin = "";
  showQA = false;
  rules = {
    phone: [
      { required: true, message: "请输入手机号", trigger: "blur" },
      {
        validator: (rule: unknown, value: string, callback: Function) => {
          if (!Reg.isMobile(value)) {
            return callback(new Error("手机号格式不正确"));
          } else {
            return callback();
          }
        },
        trigger: ["blur"]
      }
    ],
    captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
  };

  get hasMobile() {
    return this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11;
  }

  created() {
    //
  }
  mounted() {
    this.formElement = this.$refs["form"] as ElForm;
    this.locationOrigin = Config.homePageHost;
  }

  getCode() {
    if (this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11) {
      if (this.sendingCaptchaLock) {
        return;
      }
      if (this.seconds > 0) {
        return;
      }
      this.sendingCaptchaLock = true;
      // 获取验证码
      this.codeForm.phone = this.loginFrom.phone;
      Login.getCode(this.codeForm)
        .then(() => {
          this.seconds = 60;
          this.interval = setInterval(() => {
            this.seconds--;
            if (this.seconds <= 0) {
              clearInterval(this.interval);
              this.sendingCaptchaLock = false;
            }
          }, 1000);
        })
        .catch((err: any) => {
          this.captchaErrorText = err.message;
          this.captchaLoginError = true;
        })
        .finally(() => {
          this.sendingCaptchaLock = false;
        });
    }
  }

  submit() {
    if (this.loginLock) {
      return;
    }
    if (this.loginLock) return;
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        this.captchaLoginError = false;
        // if (!this.isSelected) {
        //   this.captchaErrorText = "请同意《海纳个人信息保护协议》";
        //   this.captchaLoginError = true;
        //   this.loginLock = false;
        //   return;
        // }

        this.loginLock = true;
        this.loginFrom.connectCode = this.connectCode;
        return Login.login(this.loginFrom)
          .then(info => {
            //存下
            try {
              localStorage.setItem("nrxqToken", info.nrxqToken);
            } catch (e) {
              console.log(e);
            }

            if (info.nrxqLoginStatus === "needLogin") {
              //去登陆
              this.$emit("toNRLogin");
            }
            if (info.nrxqLoginStatus === "needContent") {
              //填写信息
              this.$emit("toNRInfo", info.nrxqToken);
            }
            if (info.nrxqLoginStatus === "noNeed") {
              //直接查看
              this.$emit("ok", info.nrxqToken);
            }
          })
          .catch((err: any) => {
            this.captchaErrorText = err.message;
            this.captchaLoginError = false;
          })
          .finally(() => {
            this.loginLock = false;
          });
      }
    });
  }
}
